import { SekansPadsRow } from "./SekansPadsRow"

export const SekansPadsCard = props => {
  const activePads = props.activePads
  const stepsAmount = activePads[0].length
  const padsIndexes = props.padsIndexes
  const activeCursor = props.activeCursor
  
  return (
    <div className="padsCardContainer">
      {activePads.map((row, index) => {
        return (
          <SekansPadsRow rank={row} index={index} activeBtns={activePads[index]} padsIndexes={padsIndexes[index]} activeCursor={activeCursor[index]} handleClick={props.handleClick} stepsAmount={stepsAmount} key={index} justCleared={props.justCleared[index]} handlePointer={props.handlePointer} handleDragEnter={props.handleDragEnter} edition={props.edition} />
        )
      })}
    </div>
  )
}